import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { PlaceContext, ObjContext, MakeContext, DefeatContext } from "./context";

export class Knight extends UnitType {
    readonly id = "knight";
    readonly displayName = "Knight";
    description() { return "Provides souls when snatched.\nDefeats Fiends, Imps, Cultists and Pentagrams."; }
    canEnter(ctx: PlaceContext) { return this.inTile(ctx, ["land"], ctx.game.overworld); }
    defeats() { return ["fiend", "imp", "cultist", "pentagram"]; }
    onDefeat(ctx: DefeatContext) { ctx.game.addResource(ctx.attacker.faction, "souls", 4); }
    maxCooldown() { return 8000; }
    moveRange() { return 7; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "knight"); }
    step(ctx: ObjContext) {
        this.hunt(ctx, c => {
            const obj = c.world.get(c.x, c.y);
            return obj && this.canDefeat(obj.unitId) ? 1 : 0;
        });
    }
}
